(function () {
  const PROGRESS_SELECTOR = '[data-cart-shipping-progress]';
  const LIMIT_ATTR = 'data-free-shipping-limit';

  function getSubtotal() {
    const totalEl = document.querySelector('[data-cart-total]');
    return totalEl ? Number(totalEl.getAttribute('data-cart-total')) : 0;
  }

  function getLimitCents(element) {
    const rate = window.Shopify && window.Shopify.currency ? window.Shopify.currency.rate : 1;
    return Number(element.getAttribute(LIMIT_ATTR)) * 100 * rate;
  }

  function formatMoney(cents) {
    if (typeof Shopify !== 'undefined' && Shopify.formatMoney && window.theme && window.theme.moneyFormat) {
      return Shopify.formatMoney(cents, window.theme.moneyFormat).replace('.00', '');
    }

    return (cents / 100).toLocaleString('pt-BR', {
      style: 'currency',
      currency: 'BRL',
    });
  }

  function updateShippingProgress() {
    const subtotal = getSubtotal();

    document.querySelectorAll(PROGRESS_SELECTOR).forEach((bar) => {
      const limit = getLimitCents(bar);
      const qualified = subtotal >= limit;
      const inProgress = subtotal > 0 && !qualified;
      const percent = limit > 0 ? Math.min((subtotal / limit) * 100, 100) : 0;

      bar.classList.toggle('is-success', qualified);
      bar.classList.toggle('is-in-progress', inProgress);

      const progressBar = bar.querySelector('[data-progress-bar]');
      if (progressBar) {
        progressBar.value = percent;
      }

      const leftToSpend = bar.querySelector('[data-left-to-spend]');
      if (leftToSpend) {
        leftToSpend.innerHTML = formatMoney(Math.max(limit - subtotal, 0));
      }
    });
  }

  document.addEventListener('DOMContentLoaded', updateShippingProgress);
  document.addEventListener('theme:cart:update', updateShippingProgress);
  document.addEventListener('theme:product:added', updateShippingProgress);
  document.addEventListener('theme:cart:open', updateShippingProgress);
})();
